
import { Metamodel } from 'app/model/base/model';
import { Named } from 'app/model/base/named';
import { copyMethodOptionValues } from '../components/copy-method-setting/copy-method-setting.const';

export function dwSinkDisAllowedPolybase(dwSink: Named): boolean {
    if (dwSink != null) {
        const sinkModel = Metamodel.modelOf(dwSink);
        if (sinkModel && sinkModel.hasAttribute('allowPolyBase')) {
            if (sinkModel.hasAttribute('copyMethod')) {
                return (sinkModel.attribute('copyMethod').value(dwSink) !== copyMethodOptionValues.PolyBase) ||
                    (!sinkModel.attribute('allowPolyBase').value(dwSink) && !sinkModel.attribute('allowPolyBase').templateValue(dwSink));
            } else {
                return !sinkModel.attribute('allowPolyBase').value(dwSink) && !sinkModel.attribute('allowPolyBase').templateValue(dwSink);
            }
        }
    }
    return false;
}

export function dwSinkDisAllowedCopyCommand(dwSink: Named): boolean {
    if (dwSink != null) {
        const sinkModel = Metamodel.modelOf(dwSink);
        if (sinkModel && sinkModel.hasAttribute('allowCopyCommand')) {
            return !(sinkModel.attribute('allowCopyCommand').value(dwSink)) && !(sinkModel.attribute('allowCopyCommand').templateValue(dwSink));
        }
    }
    return false;
}
